<!-- 折线图 -->
<template>
  <div
    class="bar-chart"
    :id="chartId"
    :style="{
      backgroundColor:
        this.chartData.series && this.chartData.series.length == 0
          ? '#F8F8F8'
          : '#fff',
    }"
  ></div>
</template>

<script>
import { resizeDetector, setNotopt } from "@/config/utils";
export default {
  name: "BarChart",
  props: {
    // id
    chartId: {
      type: String,
      required: true,
    },
    // 数据
    chartData: {
      type: Object,
      required: true,
    },
    // 名称
    text: {
      type: String,
      required: false,
    },
    // 是否显示图例(默认不显示)
    isLegend: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {
    this.initChart();
    this.resizeDetector(this, this.chartId); // 动态调整页面大小 1. this, 2. id名称
  },
  methods: {
    resizeDetector,
    initChart() {
      let myChart = this.$echarts.init(document.getElementById(this.chartId));
      let seriesArr = [];
      if (this.chartData.series && this.chartData.series.length == 0) {
        return setNotopt(myChart, "暂无数据");
      }
      this.chartData &&
        this.chartData.series &&
        this.chartData.series.map((item, index) => {
          seriesArr.push({
            name: item.name, // 值名称
            type: item.type || "line", // 类型
            data: item.data, // 值 Array
            barWidth: item.widthVal,
            emphasis: {
              // 鼠标滑入
              borderColor: "#FFFFFF",
              borderWidth: 1,
              shadowColor: "rgba(61,134,213,0.14)",
            },
            yAxisIndex: item.yAxisIndex ? item.yAxisIndex : null,
            itemStyle: item.itemStyle || {},
            barWidth: 20,
            symbol: "circle",
            // symbolSize: 14,
            color: "#578AC1",
            lineStyle: {
              normal: {
                width: 2,
                color: "#AAAAAA", //设置实线的颜色
              },
            },
          });
        });
      let option = {
        title: {
          text: this.text || "", // 标题名称
          left: 0,
          top: 0,
          textStyle: {
            fontSize: 14,
            color: "rgba(0,0,0,0.85)",
            fontWeight: 500,
            fontFamily: "PingFangSC, PingFangSC-Medium",
          },
        },
        dataZoom: {
          start: 0, //默认为0
          end: 100, //  默认为100（重点）
          type: "slider",
          show: true,
          borderColor: "transparent",
          borderCap: "round",
          xAxisIndex: [0],
          height: 12, //组件高度
          left: 30, //左边的距离
          right: 30, //右边的距离
          bottom: 24, //右边的距离
          fillerColor: "#6FA2DA",
          handleIcon: "path://M512,512m-448,0a448,448,0,1,0,896,0a448,448,0,1,0,-896,0Z",
          handleSize: "100%",
          borderRadius: 100,
          handleStyle: {
            color: "#fff",
            borderWidth: 2,
            borderColor: "#0B51C1",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
          },
          backgroundColor: "#EBF0FB", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          filterMode: "filter",
          brushSelect: false,
          showDataShadow: false,
        },
        grid: {
          // 图表的位置
          left: 30,
          top: 30,
          bottom: 60,
          right: 30,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis", // 触发类型
          confine: true,
          extraCssText: "white-space: normal; word-break: break-all;",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            fontWeight: "normal",
            color: "rgba(0,0,0,0.65)", // 文字颜色
            fontSize: 12,
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData && this.chartData.xAxis,
            splitLine: {
              show: false,
            },
            axisTick: {
              lineStyle: {
                color: "#e9e9e9",
              },
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#E9E9E9",
              },
            },
            axisLabel: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 12,
              align: "center",
              margin: 16,
              // interval: 0, // 横轴信息全部显示
            },
          },
        ],
        yAxis: [
          {
            // name: this.chartData.yAxisName || "生产批次",
            nameLocation: "middle", // 名称位置
            // offset: 10,
            type: "value",
            position: "left",
            // minInterval: 1, // 设置成1保证坐标轴分割刻度显示成整数
            nameTextStyle: {
              fontSize: 12,
              color: "#999999",
              padding: [0, 0, -15, 240],
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 12,
              margin: this.unit ? 36 : 15,
              interval: 0, //强制文字产生间隔
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: ["#E9E9E9"],
              },
            },
          },
        ],
        series: seriesArr,
      };
      if (this.isLegend) {
        option.legend = {
          // 图例
          show: true,
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            // 文本样式
            fontSize: 12,
            color: "rgba(0,0,0,0.65)",
          },
          itemGap: 20,
          bottom: 0,
          selectedMode: this.chartData.selectedMode || true, // 禁止点击,默认可点击
        };
      }
      myChart.clear();
      myChart.setOption(option);
    },
  },
  watch: {
    chartData(newVal, oldVal) {
      if (newVal && JSON.stringify(newVal) !== "{}") {
        this.initChart();
      }
    },
  },
};
</script>
<style scoped lang="less">
.bar-chart {
  width: 100%;
  height: 100%;
}
</style>
